// ---------------------------------------------------------------------------
// The bench tickets of sales that were rung up offline, printed once the
// server has recorded them.
//
// An offline sale prints its RECEIPT at the moment of the sale, through the
// shop's print agent. Its preparation tickets cannot exist then - they are
// written by the server when the sale is recorded - so the synchronisation
// answer names them, and this mounts the ordinary print sheets for exactly
// those documents. Same plan shape, same idempotent job keys, same printers:
// a plan mounted twice sends nothing twice.
// ---------------------------------------------------------------------------

import { useEffect } from 'react';
import { NetworkPrintSheets } from './NetworkPrintSheets';
import { useOfflineStore } from '../../stores/offlineStore';
import { usePermission } from '../../hooks/usePermissions';

export function SyncedTicketPrints() {
  const plans = useOfflineStore((state) => state.ticketPlans);
  const remove = useOfflineStore((state) => state.removeTicketPlan);
  const allowed = usePermission('kitchen_tickets.print');

  // A till whose user may not print tickets cannot render them: the ticket
  // request would be refused and the sheet would wait for ever. Dropped, so
  // nothing hangs; the bench's paper is then a manual print from Orders.
  useEffect(() => {
    if (allowed) return;
    for (const plan of plans) remove(plan.saleId);
  }, [allowed, plans, remove]);

  if (!allowed) return null;

  return (
    <>
      {plans.map((plan) => (
        <NetworkPrintSheets
          key={plan.saleId ?? plan.orderId ?? 'plan'}
          plan={plan}
          sale={null}
          onSettled={() => remove(plan.saleId)}
        />
      ))}
    </>
  );
}
